import script from "./CallRecords.vue?vue&type=script&lang=ts&setup=true"
export * from "./CallRecords.vue?vue&type=script&lang=ts&setup=true"

import "./CallRecords.vue?vue&type=style&index=0&id=79f44ce3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79f44ce3"]])

export default __exports__